import type { WhitelabelTemplateValue } from "./featureFlags"

export const domains: Record<string, WhitelabelTemplateValue> = {
  "near-intents.org": "near-intents",
  "solswap.org": "solswap",
  "dogecoinswap.org": "dogecoinswap",
  "turboswap.org": "turboswap",
  "trump-swap.org": "trumpswap",
  "rabitswap.org": "rabitswap",
  "omniswap.com": "omniswap",
}
